import { Sheet, SheetContent, SheetTitle } from "@/app/admin/_common/ui/sheet";
import { useMobileNavStore } from "@/app/_store/mobileNavStore";
import { NavigationContent } from "./Navigation";

export default function MobileNavSheet() {
  const open = useMobileNavStore((s) => s.open);
  const setOpen = useMobileNavStore((s) => s.setOpen);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="left"
        hideClose
        className="flex h-full w-screen max-w-none border-r-0 p-0 sm:max-w-none"
      >
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <NavigationContent className="w-screen" onRequestClose={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
}
